module.exports = __webpack_public_path__ + "2ced8eb6be61af8684896763673f56fb.pdf";